import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes"; // bzw. wo deine routes liegen
import store from "@/store";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  if (!to.meta.requiresAuth) return true;

  if (!store.getters.loggedIn) {
    store.dispatch("logout", "expired");
    return false;
  }
  return true;
});

export default router;
